module.exports = __webpack_public_path__ + "img/demand.b3fadc4d.svg";